/* Duskhaven search panel (Oct 2026). Works with the theme's search dialog (#search-modal).
 * 1. Desktop (1024px+): each time the panel opens it is anchored to the header search field, so it reads as a
 *    dropdown under the field rather than a centred modal. CSS in dh-search-panel.css uses the values set here.
 * 2. When recently viewed products load into the empty panel, the "Best sellers" fallback cards are taken out,
 *    so hidden cards never receive arrow-key selection. They come back if the shopper clears recently viewed. */
(function () {
  'use strict';
  if (window.__dhSearchPanel) return;
  window.__dhSearchPanel = true;

  var desktop = window.matchMedia('(min-width: 1024px)');

  function headerField() {
    var forms = document.querySelectorAll('dh-shopify-navigation form.dh-nav-desktop-search');
    for (var i = 0; i < forms.length; i++) {
      var rect = forms[i].getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) return rect;
    }
    return null;
  }

  function anchor(modal) {
    var style = modal.style;
    var rect = desktop.matches ? headerField() : null;
    if (!rect) {
      style.removeProperty('--dh-sp-top');
      style.removeProperty('--dh-sp-left');
      style.removeProperty('--dh-sp-width');
      return;
    }
    var viewport = document.documentElement.clientWidth || window.innerWidth;
    var width = Math.min(780, viewport - 32);
    var left = Math.max(16, Math.min(rect.left - 12, viewport - width - 16));
    var top = Math.max(12, rect.top - 10);
    style.setProperty('--dh-sp-top', Math.round(top) + 'px');
    style.setProperty('--dh-sp-left', Math.round(left) + 'px');
    style.setProperty('--dh-sp-width', Math.round(width) + 'px');
  }

  function syncFallback(modal) {
    var box = modal.querySelector('.dh-sp #predictive-search-products');
    if (!box) return;
    var fallback = box.querySelector(':scope > .dh-sp-fallback');
    var recent = box.querySelector(':scope > .recently-viewed-wrapper');
    if (recent && !recent.classList.contains('removing') && fallback) {
      modal.__dhSpFallback = fallback;
      fallback.remove();
    } else if (!recent && !fallback && modal.__dhSpFallback) {
      box.appendChild(modal.__dhSpFallback);
    }
  }

  function init() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    var dialog = modal.querySelector('dialog');
    if (dialog) {
      new MutationObserver(function () {
        if (dialog.open) anchor(modal);
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      window.addEventListener('resize', function () {
        if (dialog.open) anchor(modal);
      });
    }
    new MutationObserver(function () {
      syncFallback(modal);
    }).observe(modal, { childList: true, subtree: true });
    syncFallback(modal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
